import React, { ChangeEventHandler, FC, useState } from 'react'

import { SwitchProps } from '@/types'
import { getStyledElementProps } from '@/utils'

import styles from './switch.module.scss'

export const Switch: FC<SwitchProps> = ({
  name,
  multiple,
  checked,
  defaultChecked,
  onChange,
  onBlur,
  value = '',
  containerProps = {},
  wrapperProps = {},
  thumbProps = {},
  trackProps = {},
  inputProps = {},
}) => {
  const styledContainerProps = getStyledElementProps(
    containerProps,
    styles['container']
  )
  const styledThumbProps = getStyledElementProps(thumbProps, styles['thumb'])
  const styledInputProps = getStyledElementProps(inputProps, styles['input'])

  const styledTrackProps = getStyledElementProps(trackProps, styles['track'])
  const { className: styledTrackPropsClassName, ...trackRestProps } =
    styledTrackProps

  const styledWrapperProps = getStyledElementProps(
    wrapperProps,
    styles['wrapper']
  )
  const { className: styledWrapperPropsClassName, ...spanRestProps } =
    styledWrapperProps
  const [isChecked, setIsChecked] = useState(checked || defaultChecked)

  const handleInputChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    setIsChecked(!isChecked)
    onChange && onChange(event)
  }

  return (
    <span {...styledContainerProps}>
      <span
        className={`${styledWrapperPropsClassName} ${
          isChecked ? `${styles['wrapper--checked']}` : ''
        }`}
        {...spanRestProps}
      >
        <input
          type="checkbox"
          name={name}
          value={value}
          multiple={multiple}
          checked={checked}
          defaultChecked={defaultChecked}
          onChange={handleInputChange}
          onBlur={onBlur}
          {...styledInputProps}
        />
        <span {...styledThumbProps} />
      </span>
      <span
        className={`${styledTrackPropsClassName} ${
          isChecked ? `${styles['track--checked']}` : ''
        }`}
        {...trackRestProps}
      />
    </span>
  )
}
